import React from 'react'
import { ROUTE_USER_ACCOUNT } from '../../routes'
import { TAG_CLICK_USER_BURGER } from '../../store/analytics/analytics.actionTypes'
import { navigateTo } from '../../store/history/history.actions'
import TagActionButton from '../genericComponents/TagActionButton'
import hamburger from '../genericComponents/assets/hamburger.svg'
import SVGIcon from '../svg/SVGIcon'
import { useAction } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'
import s from './UserButton.less'
import UserPicture from './UserPicture'

const UserButton = () => {
  const execNavigateTo = useAction(navigateTo)
  const onClick = useEventCallback(() => {
    execNavigateTo({
      route: ROUTE_USER_ACCOUNT
    })
  })

  return (
    <TagActionButton type={TAG_CLICK_USER_BURGER} className={s.root} onClick={onClick} deferClick>
      <div className={s.avatar}>
        <UserPicture />
      </div>
      <div className={s.menu}>
        <SVGIcon url={hamburger} />
      </div>
    </TagActionButton>
  )
}

export default UserButton
